import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Waves, Check, Users, Calendar, Trophy, ArrowLeft, Zap, Target, Award, Clock, GraduationCap, Dumbbell } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
const trainingPrograms = [{
  icon: GraduationCap,
  title: 'הדרכה אישית',
  description: 'ליווי אישי צמוד למי שרוצה להשתפר בחתירה ספורטיבית',
  features: ['תוכנית אימונים אישית מותאמת', 'שיפור טכניקה ומהירות', 'תזונה וכושר כללי']
}, {
  icon: Dumbbell,
  title: 'אימוני כוח וסבולת',
  description: 'תוכנית אימונים משלימה לשיפור ביצועים',
  features: ['אימוני אינטרוולים במים', 'תרגילי כוח ליבה ויציבות', 'אימוני סבולת למרחקים ארוכים', 'שיפור מהירות ספרינט']
}];
const benefits = [{
  icon: Zap,
  title: 'שיפור ביצועים',
  description: 'אימוני מהירות וסבולת ממוקדים לשיפור כושר וטכניקה'
}, {
  icon: Users,
  title: 'קהילת חותרים ספורטיבית',
  description: 'הצטרפו לקהילת חותרים המחויבים להשתפר'
}, {
  icon: Award,
  title: 'חתירה ברמה גבוהה',
  description: 'ליווי מקצועי לחתירה ספורטיבית ואיכותית'
}, {
  icon: Target,
  title: 'מעקב אישי',
  description: 'תוכנית אימונים אישית ומעקב אחר התקדמות'
}];
export function SUPPage() {
  useEffect(() => {
    // Set meta tags for SUP page
    document.title = "SUP - חתירה בעמידה | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "חתירה על סאפ בכנרת - הדרכות אישיות וקבוצות אימון, קהילת חותרים פעילה, ציוד מקצועי. הצטרפו למועדון ביץ' קלאב מעגן");
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "SUP - חתירה בעמידה | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'חתירה על סאפ בכנרת - הדרכות, קבוצות אימון וקהילת חותרים פעילה'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hhg6LtFE9yaLy4GHP6mfvz/20240328_164359.jpg'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "SUP - חתירה בעמידה | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'חתירה על סאפ בכנרת - הדרכות וקבוצות אימון'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hhg6LtFE9yaLy4GHP6mfvz/20240328_164359.jpg'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-800">
      <Navigation data-id="element-801" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-802">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-803" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hhg6LtFE9yaLy4GHP6mfvz/20240328_164359.jpg" alt="SUP Activity" className="w-full h-full object-cover" data-id="element-804" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-805">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-806">
            SUP
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-807">
            חתירה בעמידה - החיבור המושלם בין גוף, נפש וטבע
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-808">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-809">
          <div data-id="element-810">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-811">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-812">
              חתירה על סאפ (Stand Up Paddleboard) היא אחת הפעילויות הימיות
              הצומחות ביותר בעולם, ובצדק. היא משלבת עבודה על שרירי הליבה, שיפור
              שיווי המשקל, וחיבור ישיר ושקט למים ולטבע. במועדון שלנו תמצאו את
              הציוד המתקדם ביותר ומדריכים מנוסים שילוו אתכם מהצעד הראשון ועד
              לחתירה מקצועית.
            </p>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-813">
              למה לבחור ב-SUP?
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-814">
              {['אימון גופני מלא (Full Body Workout)', 'מתאים לכל הגילאים ולכל רמות הכושר', 'פעילות מרגיעה ומפחיתת לחצים', 'חיבור לקהילה תומכת ופעילה'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-815">
                  <div className="bg-blue-100 p-1 rounded-full" data-id="element-816">
                    <Check className="w-4 h-4 text-[#0A5F8F]" data-id="element-817" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-818">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-819">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-820">
              <div className="flex gap-4" data-id="element-821">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-822">
                  <Users className="w-6 h-6 text-blue-500" data-id="element-823" />
                </div>
                <div data-id="element-824">
                  <h4 className="font-bold text-lg mb-1" data-id="element-825">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-826">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד חותרים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-827">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-828">
                  <Waves className="w-6 h-6 text-blue-500" data-id="element-829" />
                </div>
                <div data-id="element-830">
                  <h4 className="font-bold text-lg mb-1" data-id="element-831">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-832">
                    שלושה אימונים שבועיים קבוצתיים ברמות שונות - קבוצה לחותרים
                    שרוצים להעלות דופק ולחתור במהירות, וקבוצה לחותרי סאפ שרוצים
                    לחתור בקצב שלהם, להתחבר לטבע, ולעצור לתרגילי גמישות וכוח.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-833">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-834">
                  <Users className="w-6 h-6 text-blue-500" data-id="element-835" />
                </div>
                <div data-id="element-836">
                  <h4 className="font-bold text-lg mb-1" data-id="element-837">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-838">
                    הצטרפו לקהילת חותרים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-839">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-840">
                  <Calendar className="w-6 h-6 text-blue-500" data-id="element-841" />
                </div>
                <div data-id="element-842">
                  <h4 className="font-bold text-lg mb-1" data-id="element-843">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-844">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-845">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-846">
                  <Waves className="w-6 h-6 text-blue-500" data-id="element-847" />
                </div>
                <div data-id="element-848">
                  <h4 className="font-bold text-lg mb-1" data-id="element-849">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-850">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-851">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-852">
                  <Waves className="w-6 h-6 text-blue-500" data-id="element-853" />
                </div>
                <div data-id="element-854">
                  <h4 className="font-bold text-lg mb-1" data-id="element-855">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-856">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-857">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-858">
                תיאום שיעור ניסיון
              </Button>
            </div>
          </div>
        </div>

        {/* SUP Race Introduction */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-20 mb-12 max-w-4xl mx-auto text-center" data-id="element-859">
          <h3 className="text-3xl md:text-4xl font-bold text-[#0A5F8F] mb-6" data-id="element-860">
            למי שרוצה לקחת לקצה
          </h3>
          <p className="text-xl text-gray-700 leading-relaxed" data-id="element-861">
            למי שרוצה לקחת לקצה, להעלות דופק ולהגדיל נפחים - אנחנו המועדון
            היחידי בארץ שמציע שיעורים והשכרות ב-SUP RACE.
          </p>
        </motion.div>

        {/* SUP Race Link Box */}
        <div className="mb-20" data-id="element-862">
          <Link to="/sup-race" data-id="element-863">
            <motion.div whileHover={{
            scale: 1.02
          }} className="bg-gradient-to-br from-yellow-50 to-orange-50 border-2 border-yellow-200 rounded-2xl p-6 cursor-pointer group max-w-4xl mx-auto" data-id="element-864">
              <div className="flex items-center gap-4" data-id="element-865">
                <div className="bg-white p-3 rounded-xl shadow-sm" data-id="element-866">
                  <Trophy className="w-8 h-8 text-yellow-500" data-id="element-867" />
                </div>
                <div className="flex-1" data-id="element-868">
                  <h3 className="text-xl font-bold text-gray-900 mb-1 flex items-center gap-2" data-id="element-869">
                    מתעניינים ב-SUP Race?
                    <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" data-id="element-870" />
                  </h3>
                  <p className="text-gray-700" data-id="element-871">
                    לחצו כאן למידע מלא על אימונים, הדרכות והשכרת ציוד למתחרים.
                  </p>
                </div>
              </div>
            </motion.div>
          </Link>
        </div>

        {/* What is SUP Race Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center mb-20" data-id="element-872">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-6" data-id="element-873">
            מה זה SUP Race?
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-874">
            SUP Race הוא חתירה ספורטיבית בעמידה על גלשן צר, ארוך ומהיר. הגלשנים
            מיועדים למהירות מקסימלית - ברוחב של 20-28 אינץ' ובאורך אחיד של 14
            פיט. זהו ספורט המדגיש כוח, סבולת, טכניקה ואסטרטגיה.
          </p>
        </motion.div>

        {/* Unique Advantage */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-3xl p-12 mb-20 border-2 border-yellow-200" data-id="element-875">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-876">
            <div className="bg-white p-6 rounded-2xl shadow-lg" data-id="element-877">
              <Award className="w-16 h-16 text-yellow-500" data-id="element-878" />
            </div>
            <div className="flex-1 text-center md:text-right" data-id="element-879">
              <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-880">
                המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-881">
                אנחנו גאים להיות המועדון הראשון והיחיד בישראל שמציע קבוצת אימון
                ייעודית לחתירה ספורטיבית. עם מאמנים מוסמכים, ציוד מקצועי,
                ותוכנית אימונים מובנית - מתאים לכל מי שרוצה להשתפר ולחתור ברמה
                גבוהה יותר, ולמי שמעוניין גם להתחרות.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Training Programs Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-882">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4 text-center" data-id="element-883">
            אימונים והדרכות
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-884">
            תוכניות אימון מקצועיות והדרכה אישית לכל מי שרוצה להשתפר
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 max-w-4xl mx-auto" data-id="element-885">
            {trainingPrograms.map((program, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl border border-blue-100" data-id="element-886">
                <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-md" data-id="element-887">
                  <program.icon className="w-8 h-8 text-[#0A5F8F]" data-id="element-888" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-889">
                  {program.title}
                </h3>

                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-890">
                  {program.description}
                </p>

                <ul className="space-y-2" data-id="element-891">
                  {program.features.map((feature, i) => <li key={i} className="flex items-start gap-2 text-gray-700" data-id="element-892">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#0A5F8F] mt-2" data-id="element-893" />
                      <span className="text-sm" data-id="element-894">{feature}</span>
                    </li>)}
                </ul>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Race Group - Single Group */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-895">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4 text-center" data-id="element-896">
            הקבוצה שלנו
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-897">
            קבוצת אימון אחת לכל הרמות, עם אימונים מותאמים אישית
          </p>

          <div className="max-w-2xl mx-auto" data-id="element-898">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300" data-id="element-899">
              <div className="h-2 bg-gradient-to-r from-blue-500 to-cyan-400" data-id="element-900" />

              <div className="p-8" data-id="element-901">
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 mx-auto" data-id="element-902">
                  <Trophy className="w-8 h-8 text-[#0A5F8F]" data-id="element-903" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-904">
                  קבוצת חתירה ספורטיבית
                </h3>
                <div className="inline-block px-3 py-1 rounded-full text-sm font-bold mb-4 bg-gradient-to-r from-blue-500 to-cyan-400 text-white mx-auto block w-fit" data-id="element-905">
                  All Levels
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed text-center" data-id="element-906">
                  קבוצה אחת המאחדת חותרים בכל הרמות - ממתחילים ועד מתקדמים. כל
                  חותר מקבל תוכנית אימונים אישית המותאמת לרמתו ויעדיו האישיים.
                  הדגש הוא על שיפור מתמיד וחתירה ספורטיבית ברמה גבוהה.
                </p>

                <div className="flex items-center justify-center gap-2 text-gray-700" data-id="element-907">
                  <Clock className="w-5 h-5 text-[#0A5F8F]" data-id="element-908" />
                  <span className="font-semibold text-lg" data-id="element-909">
                    3-4 אימונים בשבוע
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Benefits Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-910">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-12 text-center" data-id="element-911">
            למה להצטרף לקבוצה שלנו?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-912">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -30 : 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-6 p-6 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-100" data-id="element-913">
                <div className="bg-white p-4 rounded-xl shadow-sm h-fit" data-id="element-914">
                  <benefit.icon className="w-8 h-8 text-[#0A5F8F]" data-id="element-915" />
                </div>
                <div data-id="element-916">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-917">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-918">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Equipment Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gray-50 rounded-3xl p-12 mb-20" data-id="element-919">
          <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6 text-center" data-id="element-920">
            הציוד שלנו
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-921">
            <div data-id="element-922">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-923">
                גלשני RACE מקצועיים
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-924">
                <li className="flex items-start gap-2" data-id="element-925">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-926" />
                  <span data-id="element-927">גלשנים צרים ומהירים ברוחב 20-28 אינץ'</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-928">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-929" />
                  <span data-id="element-930">אורך אחיד של 14 פיט לכל הגלשנים</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-931">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-932" />
                  <span data-id="element-933">ציוד מקצועי לחתירה ספורטיבית</span>
                </li>
              </ul>
            </div>
            <div data-id="element-934">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-935">
                משוטים מקצועיים
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-936">
                <li className="flex items-start gap-2" data-id="element-937">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-938" />
                  <span data-id="element-939">משוטי קרבון קלים ויעילים</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-940">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-941" />
                  <span data-id="element-942">ציוד איכותי לחתירה מקצועית</span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>

      <ContactSection data-id="element-943" />
      <Footer data-id="element-944" />
    </div>;
}